
// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getNotificationProfessionalHeaders } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitGetNotificationProfessionalApi = createAsyncThunk(
  "hitGetNotificationProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getNotificationProfessionalHeaders;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const GetNotificationProfessionalSlice = createSlice({
  name: "getNotificationProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
    status: null,
    isError: false,
  },
  reducers: {
    clearhitGetNotificationProfessionalData: (state) => {
      state.data = null;
      state.status = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitGetNotificationProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitGetNotificationProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.status = action.payload.status;
        state.data = action.payload;
      })
      .addCase(hitGetNotificationProfessionalApi.rejected, (state) => {
          state.status = false;
        state.isError = false;
        
      });
  },
});

export const { clearhitGetNotificationProfessionalData } = GetNotificationProfessionalSlice.actions;
export default GetNotificationProfessionalSlice.reducer;